<template>
    <div class="automation-wizard-field-text">
        <CompassFormItem v-bind="formItemProps" :error="field.currentError || ''">
            <CompassInput
                v-model="localValue"
                :type="type"
                menuClass="automation-wizard-field-text"
                class="typographies-paragraph-medium-regular"
            >
            </CompassInput>
        </CompassFormItem>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: [String, Number, Object],
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
    },
    emits: ['update:value'],
    data() {
        return {
            localValue: '',
        };
    },
    computed: {
        formItemProps() {
            return {
                ...this.field.props?.formItem,
                label: this.field.props?.formItem?.label || '',
                required: this.field.required || false,
                requiredLabel:
                    this.field.props?.formItem?.requiredLabel ||
                    this.$t.__('common.labels.required'),
            };
        },
    },
    watch: {
        value: {
            async handler(newValue) {
                this.localValue = newValue || '';
            },
            immediate: true,
        },
        localValue(newValue) {
            this.$emit('update:value', newValue);
        },
    },
};
</script>
